import { useCallback, useState } from 'react'

import { useFlags } from '@joor/launchdarkly-react-client-sdk'
import { useSelector } from 'react-redux'

import { toGlobalId } from 'utils/transformations/graphql'

import { getAccountId } from 'store/currentUser/selectors'

import { useAccountPaymentProvidersQuery } from '../Review/review.queries'

export const LIST_TABS = ['allOrders', 'joorPayOrders'] as const
export type ListTab = (typeof LIST_TABS)[number]

const ALL_ORDERS_TAB_INDEX = LIST_TABS.indexOf('allOrders')
const JOOR_PAY_ORDERS_TAB_INDEX = LIST_TABS.indexOf('joorPayOrders')

export const useTabs = (initialTab?: ListTab) => {
  const initialActiveTabIndex = LIST_TABS.indexOf(initialTab ?? 'allOrders')

  const [activeTabIndex, setActiveTabIndex] = useState<number>(
    initialActiveTabIndex,
  )

  const handleAllOrdersTab = useCallback(() => {
    setActiveTabIndex(ALL_ORDERS_TAB_INDEX)
  }, [])

  const handleJoorPayOrdersTab = useCallback(() => {
    setActiveTabIndex(JOOR_PAY_ORDERS_TAB_INDEX)
  }, [])

  return { activeTabIndex, handleAllOrdersTab, handleJoorPayOrdersTab }
}

export const useJoorPayState = () => {
  const accountId = useSelector(getAccountId)
  const { joorPayUseReach } = useFlags()

  const brandId = joorPayUseReach
    ? (toGlobalId('Brand', accountId) ?? '')
    : undefined

  const { data: paymentProvidersData, loading } =
    useAccountPaymentProvidersQuery(brandId)

  const isJoorPayEnabled = paymentProvidersData?.accountPaymentProviders?.some(
    (item: any) => item.paymentProvider === 'reach',
  )

  return {
    isJoorPayEnabled,
    paymentProvidersLoading: loading,
  }
}
